import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
import { salesNotifications } from '../data/salesNotifications';
import { bibleConfig } from '../data/bibleConfig';
import { safeUrl } from '../utils/safeUrl';
const FIRST_DELAY = 6500;
const VISIBLE_MS = 6500;
const GAP_MS = 9500;
export function BibleSalesToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const cover = safeUrl(bibleConfig.images.bible);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => {
          setIndex(current => (current + 1) % salesNotifications.length);
        }, 600);
      }, VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [index, dismissed]);
  const item = salesNotifications[index];
  return <AnimatePresence data-id="element-40" data-mp="2xcs4hbtou9u3">
      {visible && !dismissed ? <motion.div key={item.id} role="status" aria-live="polite" initial={{
      opacity: 0,
      x: -28,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -28,
      y: 12
    }} transition={{
      type: 'spring',
      stiffness: 280,
      damping: 26
    }} className="fixed bottom-[86px] left-3 z-30 w-[19rem] max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-xl border border-[#7b663b] bg-[linear-gradient(180deg,#17151c,#0e0d11)] p-3 shadow-[0_18px_44px_rgba(0,0,0,0.7)] md:left-5" data-id="element-41" data-mp="2xc9yvol4yj9i">
          <div className="flex items-center gap-3" data-id="element-42" data-mp="24nmc1okqnltu">
            {cover ? <span className="flex-shrink-0 overflow-hidden rounded-md border border-[#2c2a30] bg-[#0b0b0e]" data-id="element-43" data-mp="1v0idg2p7vr2t">
                <img src={cover} alt="" aria-hidden="true" loading="lazy" decoding="async" width={36} height={48} className="h-12 w-9 object-cover object-top" data-id="element-44" data-mp="1zzbnfl5aozy8" />
              </span> : null}

            <div className="min-w-0 flex-1" data-id="element-45" data-mp="2dt3217xvva0t">
              <p className="flex items-center gap-1.5 text-[9px] uppercase tracking-[0.16em] text-[#e9c769]" data-id="element-46" data-mp="2iqmhuca8buuv">
                Compra reciente
                <BadgeCheck aria-hidden="true" className="h-3 w-3" data-id="element-47" data-mp="24yfzcjjltbs9" />
              </p>
              <p className="mt-1 truncate text-[12.5px] font-bold text-[#f7f2e8]" data-id="element-48" data-mp="28yyqschl4ftx">
                {item.name} · {item.city}
              </p>
              <p className="truncate text-[11.5px] text-[#beb9b0]" data-id="element-49" data-mp="31gkkgcv9cvr4">
                Obtuvo el acceso por{' '}
                <span className="font-bold text-[#e9c769]" data-id="element-50" data-mp="q1c1q1ohb7zx">$11.99</span>
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.14em] text-[#7d7a84]" data-id="element-51" data-mp="l2ijjvy8ystf">
                Hace {item.minutesAgo} min · Verificado
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones de compra" className="-mr-0.5 -mt-0.5 self-start rounded p-1 text-[#6f6c76] transition-colors hover:text-[#f7f2e8]" data-id="element-52" data-mp="zthngto50t6o">
              <X className="h-3.5 w-3.5" data-id="element-53" data-mp="25hgwhs614sn" />
            </button>
          </div>

          <motion.span key={`${item.id}-bar`} initial={{
        scaleX: 1
      }} animate={{
        scaleX: 0
      }} transition={{
        duration: VISIBLE_MS / 1000,
        ease: 'linear'
      }} aria-hidden="true" className="mt-2.5 block h-[2px] origin-left rounded-full bg-[linear-gradient(90deg,#e9c769,#e995b3)]" data-id="element-54" data-mp="h1ozxeru806c" />
        </motion.div> : null}
    </AnimatePresence>;
}